import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const BackgroundContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#000000',
  // backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Crect fill='%23000000' width='2000' height='1500'/%3E%3Cdefs%3E%3Crect fill='none' stroke-width='130.8' stroke-opacity='1' id='a' x='-400' y='-300' width='800' height='600'/%3E%3C/defs%3E%3Cg transform='' style='transform-origin:center'%3E%3Cg transform='' style='transform-origin:center'%3E%3Cg transform='rotate(-153.6 0 0)' style='transform-origin:center'%3E%3Cg transform='translate(1000 750)'%3E%3Cuse stroke='%23000' href='%23a' transform='rotate(9.6 0 0) scale(1.096)'/%3E%3Cuse stroke='%23050a04' href='%23a' transform='rotate(19.2 0 0) scale(1.192)'/%3E%3Cuse stroke='%23091409' href='%23a' transform='rotate(28.8 0 0) scale(1.288)'/%3E%3Cuse stroke='%230e1f0d' href='%23a' transform='rotate(38.4 0 0) scale(1.384)'/%3E%3Cuse stroke='%23122911' href='%23a' transform='rotate(48 0 0) scale(1.48)'/%3E%3Cuse stroke='%23173316' href='%23a' transform='rotate(57.6 0 0) scale(1.576)'/%3E%3Cuse stroke='%231c3d1a' href='%23a' transform='rotate(67.2 0 0) scale(1.672)'/%3E%3Cuse stroke='%2320471e' href='%23a' transform='rotate(76.8 0 0) scale(1.768)'/%3E%3Cuse stroke='%23255223' href='%23a' transform='rotate(86.4 0 0) scale(1.864)'/%3E%3Cuse stroke='%23295c27' href='%23a' transform='rotate(96 0 0) scale(1.96)'/%3E%3Cuse stroke='%232e662b' href='%23a' transform='rotate(105.6 0 0) scale(2.056)'/%3E%3Cuse stroke='%23337030' href='%23a' transform='rotate(115.2 0 0) scale(2.152)'/%3E%3Cuse stroke='%23377a34' href='%23a' transform='rotate(124.8 0 0) scale(2.248)'/%3E%3Cuse stroke='%233c8538' href='%23a' transform='rotate(134.4 0 0) scale(2.344)'/%3E%3Cuse stroke='%23408f3d' href='%23a' transform='rotate(144 0 0) scale(2.44)'/%3E%3Cuse stroke='%23459941' href='%23a' transform='rotate(153.6 0 0) scale(2.536)'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
  backgroundAttachment: 'fixed',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

function LoadingScreen() {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const hasLabsPermission = useSelector((state) => state.auth.hasLabsPermission);
  
    if (!isAuthenticated && !hasLabsPermission) {
      // Si no está autenticado, redirigir a la página de error 404
      return <Navigate to="/login" />;
    }
    // Si está autenticado, navegar a home
    return <Navigate to="/menu" />;
    

  return (
    <BackgroundContainer>
      <Box className="flex flex-col items-center">
        <CircularProgress className="text-green-500 mb-4" size={60} />
        <Typography
          variant="h6"
          component="p"
          className="text-white text-xl font-semibold"
        >
          Cargando, por favor espera...
        </Typography>
      </Box>
    </BackgroundContainer>
  );
}

export default LoadingScreen;
